/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {FormlyUploadComponent as Éµa} from './upload.component';